<template>
  <div class="grade-range-wrapper w-100">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <eg-b-form-input
        :value="rangeMinValue"
        placeholder="From"
        type="number"
        class="grade-range-input"
        :min="min"
        :max="rangeMaxValue - 1"
        @blur="(data) => changeRangeMinValue(Number(data.target.value))"
      />
      <eg-b-form-input
        :value="rangeMaxValue"
        placeholder="To"
        type="number"
        class="grade-range-input"
        :min="rangeMinValue + 1"
        :max="max"
        @blur="(data) => changeRangeMaxValue(Number(data.target.value))"
      />
    </div>

    <RangeSelector
      :min-value="rangeMinValue"
      :max-value="rangeMaxValue"
      :min="min"
      :max="max"
      minmax-indicator
      @update:minValue="(data) => changeRangeMinValue(data)"
      @update:maxValue="(data) => changeRangeMaxValue(data)"
    />
  </div>
</template>

<script>
import RangeSelector from "@/components/global/eg_range_selector.vue";

export default {
  components: {
    RangeSelector,
  },

  props: {
    value: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      rangeMinValue: null,
      rangeMaxValue: null,
      min: 0,
      max: 100,
    };
  },

  created() {
    this.rangeMinValue = this.value?.gradeFrom || null;
    this.rangeMaxValue = this.value?.gradeTo || null;
  },

  methods: {
    changeRangeMinValue(value) {
      const clampedValue = Math.max(
        this.min,
        Math.min(value, this.rangeMaxValue)
      );

      this.rangeMinValue = clampedValue;
      this.setRange();
    },

    changeRangeMaxValue(value) {
      const clampedValue = Math.min(
        this.max,
        Math.max(value, this.rangeMinValue)
      );

      this.rangeMaxValue = clampedValue;
      this.setRange();
    },

    setRange() {
      this.$emit("input", {
        gradeFrom: this.rangeMinValue,
        gradeTo: this.rangeMaxValue,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.grade-range-wrapper {
  padding: 8px 12px;
}

.grade-range-input {
  width: 100px;
}

.dropdown-item-wrapper {
  &::v-deep {
    .dropdown-item {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
